import React, { useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useFormikContext, FieldArray, getIn } from "formik";
// components
import AlertDialog from "components/Dialog/index";
import { renderFormControl } from "components/FormManage/index";
import { MenuMultiCheckBox } from "components/MenuMultiCheckBox/MenuMultiCheckBox";
import { LabelField } from "components";
// direct import
import "../../member.scss";
import Summary from "../summary/summary";
import PricingTabsManager from "./add-pricing";
import { membershipPricing } from "../../helper";
import { formPayment, formRenewal, initialValues } from "../../helper";

const Pricing = ({ ledgers, loading }) => {
  const formik = useFormikContext();
  const { values, setFieldValue } = useFormikContext();
  // state
  const [activeTab, setActiveTab] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);

  const membershipType = values?.membershipPriceType;
  const getOpenAmountChecked =
    getIn(values, `membershipPricing[${activeTab}].openAmount`) || false;

  const isOpenAmount =
    getIn(values, `membershipPricing`)?.some((el) => el?.openAmount) || false;

  const getActiveValue =
    getIn(values, `membershipPricing[${activeTab}]`) || false;
  const handleAction = (e) => {
    if (e?.target?.checked) {
      setFieldValue(`membershipPricing[${activeTab}].amount`, 0);
    } else {
      setFieldValue(`membershipPricing[${activeTab}].amount`, '');
    }
  };

  const handleCheckboxAction = () => setOpenAlert(true);

  const isStatic = membershipType === "static";

  const handleChange = (data) => {
    setFieldValue(
      `membershipPricing[${activeTab}].tax_deductible`,
      data?.amount_detuctible ?? 0
    );
    setFieldValue(
      `membershipPricing[${activeTab}].tax_type`,
      data?.deductibleType ?? "%"
    );
  };

  const handleStaticToggle = (e) => {
    if (e.target.checked) {
      setFieldValue(`membershipPricing[${activeTab}].addAmount`, '');
    } else {
      setFieldValue(`membershipPricing[${activeTab}].amount`, '');
    }
  };

  return (
    <Grid container>
      <Grid item sm={12} md={8}>
        <Box className="info_title">
          <h2>Pricing Information</h2>
          <p>Please complete the details below</p>

          <Box sx={{ mt: 5 }}>
            <Grid container spacing={2}>
              <Grid item sm={12}>
                <Grid container spacing={2}>
                  {formRenewal(
                    handleCheckboxAction,
                    membershipType
                  )?.map((item, index) => (
                    <Grid item xs={item?.grid ?? 4} key={index} sx={{ mb: 2 }}>
                      {item?.type === "br" ? (
                        <Box
                          sx={{
                            width: "100%",
                            borderBottom: "1px solid #002e5c17",
                            height: "1px",
                            mx: "auto",
                          }}
                        />
                      ) : item?.fieldKey === "multi-ledger" ? (
                        <Box>
                          <LabelField title={item.title} mandatory />
                          <MenuMultiCheckBox
                            Items={ledgers ?? []}
                            formik={formik}
                            field={item.field}
                            withBorder={false}
                            styles={{
                              width: "100%",
                              background: "#F3F6F9",
                              borderRadius: "8px",
                              border: "none",
                              "&&  fieldset": { width: "100%", border: "none" },
                              "&:hover": { border: "none" },
                              "&.Mui-focused": { border: "none", boxShadow: "none", "&& fieldset": { border: "none" } },
                            }}
                          />
                        </Box>
                      ) : (
                        renderFormControl(item)
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>

            <FieldArray
              name="membershipPricing"
              render={(arrayHelpers) => (
                <Grid container spacing={2}>
                  <Grid item sm={12} md={3}>
                    <Box className="cost_info_left_side">
                      <Box className="cost_info_title">
                        <PricingTabsManager
                          values={values}
                          arrayHelpers={arrayHelpers}
                          activeTab={activeTab}
                          setActiveTab={setActiveTab}
                          formik={formik}
                        />
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item sm={12} md={9}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="h2" className="title_main">
                          {values?.membershipPricing?.[activeTab]?.title ?? ""}
                        </Typography>
                      </Grid>
                      {formPayment(
                        activeTab,
                        membershipType,
                        ledgers,
                        loading,
                        handleAction,
                        getOpenAmountChecked,
                        isOpenAmount,
                        getActiveValue,
                        handleChange,
                        handleStaticToggle
                      )?.map((item, index) => (
                        <Grid
                          item
                          xs={12}
                          md={item?.grid ?? 6}
                          key={item?.name || index}
                          sx={{ mb: 2 }}
                        >
                          {item?.type === "br" ? (
                            <Box
                              sx={{
                                width: "100%",
                                borderBottom: "1px solid #002e5c17",
                                height: "1px",
                                mx: "auto",
                              }}
                            />
                          ) : (
                            renderFormControl(item)
                          )}
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            />
          </Box>
        </Box>
      </Grid>

      <Grid item sm={12} md={4}>
        <Box className="class__summary">
          <Summary showRenewal={true} />
        </Box>
      </Grid>
      <AlertDialog
        open={openAlert}
        onDecline={() => {
          setOpenAlert(false);
        }}
        onAccept={() => {
          setFieldValue("membershipPricing", [membershipPricing]);
          setFieldValue(
            "ledgerForCalculation",
            initialValues?.ledgerForCalculation
          );
          setFieldValue(
            "membershipPriceType",
            !isStatic ? "static" : "dynamic"
          );
                setActiveTab(0);
          setOpenAlert(false);
        }}
        title={`Are you sure?`}
        description={`Do you want to select ${
          !isStatic ? "static" : "dynamic"
        }?`}
      />
    </Grid>
  );
};

export default Pricing;
